module.exports = __webpack_public_path__ + "media/assets/landing_page_grid_section_badges-987e0ecc.svg";